import { S25Datefilter } from "../../s25-dateformat/s25.datefilter.service";
import { S25Util } from "../../../util/s25-util";
import { SpecialDateRow } from "../../../pojo/SpecialDate";

/** US federal rows from list API (occurrence seed keys such as US_JUNETEENTH_2026). */
export function isUsFederalHolidayRow(row: SpecialDateRow): boolean {
    return !!row?.seedKey?.startsWith("US_");
}

export function specialDateRowKey(row: SpecialDateRow): string {
    if (row?.seedKey) {
        return row.seedKey;
    }
    return row?.specialDateId != null ? String(row.specialDateId) : "";
}

/** Format a civil yyyy-MM-dd (or ISO date) for display without UTC midnight parsing. */
export function formatCivilDateString(dateStr: string, dateFormat: string): string {
    const civil = S25Util.date.toCivilDateString(dateStr);
    if (!civil) {
        return "";
    }
    const localNoon = S25Util.date.parseDropTZ(`${civil}T12:00:00`);
    return S25Datefilter.transform(localNoon, dateFormat);
}
